<div class="layout-container">
	<div class="mdc-layout-grid__inner center d-flex align-items-center justify-content-center m-3 gap-0">
		<div class="mdc-layout-grid__cell--span-12">
			<img class="paymentPageImg" [src]="'/assets/images/payment/warning.svg' | s3Image" class="img-responsive" />
		</div>

		<div class="mdc-layout-grid__cell--span-12 my-3">
			<span class="text-center fs-24px fw-500 d-block mb-3">{{ locale.translations['payment']['n694'] }}</span>
			<span class="text-center fs-14px fg-grey d-block">
				{{ locale.translations['payment']['n689'] }}
			</span>
		</div>

		<div class="row w-100 mx-0" *ngIf="!embedded">
			<div class="col-12 px-0 mb-3">
				<button mat-flat-button type="submit" class="w-100 fw-400" color="primary" (click)="onYes()">
					{{ locale.translations['payment']['n690'] }}
				</button>
			</div>

			<div class="col-12 px-0">
				<button mat-stroked-button type="button" class="cancel-btn w-100 fw-400" color="primary" (click)="onNo()">
					{{ locale.translations['payment']['n691'] }}
				</button>
			</div>
			<button cdkFocusInitial hidden></button>
		</div>
	</div>
</div>
